import styled, { css } from 'styled-components';
import { StyledSideNavGroupToggle } from '../SideNavGroupToggle/styles';
import { sidenavTokens } from '../../tokens';

export type StyledSideNavTwiddleProps = { open?: boolean };

export const StyledSideNavTwiddle = styled.span<StyledSideNavTwiddleProps>`
  color: ${sidenavTokens.TwiddleFontColorBaseDefault};
  display: block;
  justify-self: flex-end;
  transition: ${`transform ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault}, color ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault}`};
  position: relative;
  top: 1px;

  ${StyledSideNavGroupToggle}:hover & {
    color: ${sidenavTokens.TwiddleFontColorBaseHover};
    transform: rotate(0deg) scale(1.45);
  }

  ${({ open }) =>
    open &&
    css`
      transform: rotate(90deg);

      ${StyledSideNavGroupToggle}:hover & {
        transform: rotate(90deg) scale(1.45);
      }
    `}
`;
